import { feature as NotificationFlowFeature } from '@central-products/notification-flow';

export const notificationFlowPlugin = {
  beforeBootstrap({ addBootstrapperFeature }) {
    addBootstrapperFeature(NotificationFlowFeature);
  },
};
